module.exports = __webpack_public_path__ + "img/tq.a4c96a64.png";